import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

function AbsenWajah() {
  const navigate = useNavigate();

  const [idSalesman, setIdSalesman] = useState('');
  const [checkInTime, setCheckInTime] = useState('');
  const [passwordCheckOut, setPasswordCheckOut] = useState('');
  const [shift, setShift] = useState('');
  const [tanggal, setTanggal] = useState('');

  const backFunction = () => {
    navigate('/');
  };

  const checkOutApi = async (idSalesman, checkInTime, shift, tanggal) => {
    const requestBody = {
      idSalesman : idSalesman,
      checkInTime : checkInTime,
      shift : shift,
      tanggal : tanggal,
      passwordAuth: passwordCheckOut, // sesuai kode awal
    };

    try {
      const response = await fetch(
        'https://api-sfasan.spsbijag.com/backend/backend_new/ScriptManagement/absen_wajah_manual.php',
        {
          mode: 'cors',
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (data.success === true) {
        alert('Sucess untuk absen wajahkan');
        navigate('/');
      } else {
        alert(`Checkout failed: ${data.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  const submit = () => {
    if (!idSalesman || !checkInTime || !shift || !tanggal) {
      alert('Isi terlebih dahulu semua field.');
      return;
    }
    if (shift.length > 255) {
      alert('Shift maksimal 255 karakter.');
      return;
    }
    const minDate = '2025-01-01';
    if (tanggal < minDate) {
      alert('Tanggal minimal 1 Januari 2025.');
      return;
    }

    // confirmAlert({
    //   title: 'Konfirmasi Ulang',
    //   message: `Apakah Anda yakin ingin mengabsenkan Salesman: ${idSalesman} pada ${tanggal} jam ${checkInTime}?`,
    //   buttons: [
    //     {
    //       label: 'Yes',
    //       onClick: () => checkOutApi(idSalesman, checkInTime, shift, tanggal),
    //     },
    //     { label: 'No', onClick: () => null },
    //   ],
    // });
    confirmAlert({
        title: 'Konfirmasi Ulang',
        message: `Apakah Anda yakin ingin mengabsenkan Salesman: ${idSalesman} pada ${tanggal} jam ${checkInTime}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              console.log("Data sebelum kirim API:");
              console.log("Id Salesman:", idSalesman);
              console.log("Check-In Time:", checkInTime);
              console.log("Shift:", shift);
              console.log("Tanggal:", tanggal);
              console.log("Password:", passwordCheckOut);
      
              // baru panggil API
              checkOutApi(idSalesman, checkInTime, shift, tanggal);
            },
          },
          { label: 'No', onClick: () => null },
        ],
      });
      
  };

  return (
    <div className="App">
      <header className="App-header">
        <button className="back-button" onClick={backFunction}>
          <FontAwesomeIcon icon={faArrowLeft} /> back
        </button>

        <h1>Absen Wajah Salesman</h1>

        {/* Row 1 */}
        <div className="input-row two-col">
          <div>
            <h5>Id Salesman</h5>
            <input
              name="idSalesman"
              maxLength={8}
              value={idSalesman}
              onChange={(e) => setIdSalesman(e.target.value)}
            />
          </div>
          <div>
            <h5>Check-In Time</h5>
            <input
              type="time"
              name="CheckInTime"
              value={checkInTime}
              onChange={(e) => setCheckInTime(e.target.value)}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="input-row two-col">
        <div className="field">
            <h5>Shift</h5>
            <input
            name="shift"
            maxLength={255}
            value={shift}
            onChange={(e) => setShift(e.target.value)}
            placeholder="Isi shift (maks 255 karakter)"
            />
            <small className="hint">misal: digantikAnASS</small>
        </div>
        <div className="field">
            <h5>Tanggal</h5>
            <input
            type="date"
            name="tanggal"
            value={tanggal}
            min="2025-01-01"
            onChange={(e) => setTanggal(e.target.value)}
            />
        </div>
        </div>


        {/* Row 3 */}
        <div className="input-row">
          <h5>Password</h5>
          <input
            name="password"
            type="password"
            value={passwordCheckOut}
            onChange={(e) => setPasswordCheckOut(e.target.value)}
          />
        </div>

        <button onClick={submit}>Absenkan Salesman</button>
      </header>
    </div>
  );
}

export default AbsenWajah;
